import { h, Component } from "preact";
import { Provider } from "unistore/preact";
import { createStore } from "./store";

import CalendarContainer from "./components/CalendarContainer";

class CalendarWidget extends Component {
    constructor(props) {
        super(props);

        this.store = createStore(props);
    }

    render(props) {
        return (
            <Provider store={this.store}>
                <CalendarContainer />
            </Provider>
        );
    }
}

export default CalendarWidget;
